export default __webpack_public_path__ + "static/media/amex.908a28ad.svg";